/*
 * Jira Ticket:
 * Created Date: Thu, 20th Feb 2020, 17:29:01 pm
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

// import { createMuiTheme } from '@material-ui/core/styles';
import { createMuiTheme } from "react-admin";
const navy = '#25455A';
const darkNavy = '#1f3a4c';
const turquoise = '#2AADB9';
const lightTurquoise = 'rgba(208, 243, 246, 0.81)';
const darkTurquoise = '#218891';
const grey = '#8f8f8f';
const lightGrey = '#e1e1e1';
const transparentOrange = 'rgba(238, 146, 104, 0.6)';
const orange = '#E55B19';
const white = '#FFFFFF';
const red = '#C60000';
const darkenedRed = '#AD0000';
const green = '#159900';
const darkenedGreen = '#008000';
const amber = '#ffaa00';
const darkenedAmber = '#E69100';

const theme = createMuiTheme({
  button: {
    color: white,
    backgroundColor: navy,
    '&:hover': {
      background: darkNavy,
    },
    '&:disabled': {
      color: white,
    },
  },
  palette: {
    primary: {
      main: turquoise,
      dark: darkTurquoise,
      light: lightTurquoise,
      contrastText: white,
    },
    secondary: {
      main: navy,
    },
    contrastThreshold: 3,
    tonalOffset: 0.2,
    type: 'light',
  },
  typography: {
    useNextVariants: true,
    fontFamily: [
      'Roboto',
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Arial',
      'sans-serif',
    ].join(','),
  },
  toolbar: {
    flex: 1,
    display: 'flex',
    justifyContent: 'space-between',
  },
});

export default theme;

export {
  navy,
  darkNavy,
  lightTurquoise,
  turquoise,
  darkTurquoise,
  transparentOrange,
  orange,
  grey,
  lightGrey,
  red,
  darkenedRed,
  green,
  darkenedGreen,
  white,
  amber,
  darkenedAmber,
};
